import React, { useState, useEffect, useMemo } from "react";
import DivTag from "../Components/DivComponent/DivTag";
import Button from "../Components/ButtonComponent/Button";
import InputWithLabel from "../Components/InputComponent/InputWithLabel";
import SelectWithLabelOption from "../Components/SelectComponent/SelectWithLabelOption";
import ReportHeading from "../Components/ReportHeadings/ReportHeadings";
import { motion } from "framer-motion";
import {
  RetriveApiKeyReportService,
  RetriveApiKeyReportServiceByFilter,
  toggleEnvService,
  toggleStatusService,
} from "../../services/apicustomerreportservice";
import { FaInbox } from "react-icons/fa";
import Seo from "../../components/SeoComponent/Seo";
import ConfirmPopUp from "../../components/Dialog/ConfirmPopup";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import PaginationData from "../../components/PaginationData";
import { AddIpService } from "../../services/Ip/AddIpService";
import { Key } from "lucide-react";
import ApiKeyModal from "../../components/ApiKeyChange/ApiKeyManager";

const CustomerReport = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [apiKeyReport, setApiKeyReport] = useState([]);
  const [isStatusToggle, setIsStatusToggle] = useState(false);
  const [isEnvToggle, setIsEnvToggle] = useState(false);
  const [userId, setuserId] = useState("");
  const [totalData, setTotalData] = useState(5);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [serviceStatus, setServiceStatus] = useState("");
  const [apiKeyReportId, setApiKeyReportId] = useState("");
  const [isLoading, setIsLoading] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [ipAddress, setIpAddress] = useState("");
  const [showIpModal, setShowIpModal] = useState(false);
  const [showIpTokenModal, setShowIpTokenModal] = useState(false);
  const [ips, setIps] = useState([]);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false)

  const isValidIP = (ip) => {
    const ipRegex =
      /^(25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})(\.(25[0-5]|2[0-4][0-9]|1?[0-9]{1,2})){3}$/;
    return ipRegex.test(ip);
  };

  function statusToggle(id) {
    setApiKeyReportId(id);
    setIsStatusToggle(true);
  }
  function envToggle(id) {
    setApiKeyReportId(id);
    setIsEnvToggle(true);
  }
  async function handleStatusToogle() {
    try {
      const respnse = await toggleStatusService({
        apiKeyId: apiKeyReportId,
      });

      if (respnse.status.code === 200) {
        setIsStatusToggle(false);
        await RetriveApiKeyReport();

        showSuccessToast(respnse.status.message);

        return;
      }
      setIsStatusToggle(false);
      showErrorToast("Failed to activate ");
      return;
    } catch (error) {
      setIsStatusToggle(false);
      showErrorToast("An Error occurs   ");
      return;
    }
  }
  async function handleEnvToogle() {
    try {
      const respnse = await toggleEnvService({
        apiKeyId: apiKeyReportId,
      });

      if (respnse.status.code === 200) {
        setIsEnvToggle(false);
        await RetriveApiKeyReport();

        showSuccessToast(respnse.status.message);

        return;
      }
      setIsEnvToggle(false);
      showErrorToast("Failed to activate ");
      return;
    } catch (error) {
      setIsEnvToggle(false);
      showErrorToast("An Error occurs   ");
      return;
    }
  }
  async function RetriveApiKeyReport() {
    try {
      setIsLoading(true);
      const response = await RetriveApiKeyReportService({
        totalData: 50,
        fromData: fromDate,
        toDate: toDate,
        userId: userId.toUpperCase(),
        serviceStatus,
        currentPage,
      });

      if (response.status.code === 200) {
        setIsLoading(false);
        setApiKeyReport(response.data);
        setPaginationData(response.pagination);
        return;
      }
    } catch (error) {
      setIsLoading(false);
      return error;
    }
  }

  function handleSetPage(page) {
    setCurrentPage(page);
  }
  useEffect(() => {
    RetriveApiKeyReport();
  }, [currentPage, totalData]);

  const handleIpChange = (e) => {
    const value = e.target.value;

    // Allow only numbers and dots
    if (/^[0-9.]*$/.test(value)) {
      setIpAddress(value);
    }
  };

  const handleGenerateToken = async (item, ip) => {
    try {
      if (item.id == null) {
        showErrorToast("Id is not provided");
        return;
      }
      if (ip == null) {
        showErrorToast("Please enter IP ");
      }

      setIsLoading(true);

      const payload = {
        user_id: item.userable.id,
        ip_address: ip,
      };

      const response = await AddIpService(payload);

      showSuccessToast(response.status.message);

      if (response.status.code === 201) {
        await RetriveApiKeyReport();
        showSuccessToast(response.status.message);
        return;
      }
    } catch (error) {
      showErrorToast("Failed to set Ip");
      setIsLoading(false);
      console.error("Error generating token:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
    >
      <Seo />
      <DivTag id="" className="mt-8 bg-white">
        <div className="flex items-center gap-2 justify-center pb-4">
          {" "}
          <ReportHeading name="API Key Report" />
          <button
          onClick={() => setShowApiKeyModal(true)}
            type="button"
            class="inline-flex items-center gap-2 mt-3 px-3.5 py-2 text-sm font-medium text-zinc-50 bg-green-600 hover:bg-zinc-800  border-zinc-800 rounded-lg shadow-sm hover:text-white transition-all duration-200 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-zinc-700"
          >
           <Key/>
            <span>Change Key</span>
          </button>{" "}
        </div>
        {isLoading && <Loader />}

        <DivTag className="flex flex-wrap gap-2 justify-center">
          <div className="flex flex-col">
            <label htmlFor="userId">Search UserId</label>
            <input
              type="text"
              className="h-8 bg-white shadow-md border-sky-500 border rounded-md outline-none px-3"
              placeholder="Search userid...."
              value={userId.toUpperCase()}
              onChange={(e) => setuserId(e.target.value)}
            />
          </div>
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-2"
            label="From Date"
            type="date"
            name="from_date"
            id="from_date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-2"
            label="To Date"
            type="date"
            name="to_date"
            id="to_date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/6 px-2"
            label="Records Per Page"
            name="total_data"
            id="total_data"
            value={totalData}
            onChange={(e) => setTotalData(e.target.value)}
          >
            <option value="">Select Record data</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </SelectWithLabelOption>
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/6 px-2"
            label="Records Per Page"
            name="total_data"
            id="total_data"
            value={serviceStatus}
            onChange={(e) => setServiceStatus(e.target.value)}
          >
            <option value="">Select status</option>
            <option value="active">Active</option>
            <option value="inactive">In Active</option>
          </SelectWithLabelOption>
        </DivTag>

        <DivTag className="flex justify-center">
          <Button
            type="button"
            onClick={RetriveApiKeyReport}
            className="bg-blue-700 text-white rounded-md px-4 py-2 hover:bg-blue-800 transition duration-300"
          >
            Search
          </Button>
        </DivTag>

        <div
          className={
            isStatusToggle
              ? "w-full h-full bg-transparent backdrop-blur-sm absolute top-0 left-0 z-50"
              : ""
          }
        >
          <ConfirmPopUp
            visible={isStatusToggle}
            onClose={() => setIsStatusToggle(false)}
            onConfirm={handleStatusToogle}
            title={"Click Yes to Continue the submission .  No For Cancel?"}
          />
        </div>

        <div
          className={
            isEnvToggle
              ? "w-full h-full bg-transparent backdrop-blur-sm absolute top-0 left-0 z-50"
              : ""
          }
        >
          <ConfirmPopUp
            visible={isEnvToggle}
            onClose={() => setIsEnvToggle(false)}
            onConfirm={handleEnvToogle}
            title={"Click Yes to Continue the submission .  No For Cancel?"}
          />
        </div>
        <DivTag className="overflow-x-auto my-1 p-2">
          <table id="table" className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr className="bg-blue-700 text-center text-white">
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  S.No{" "}
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  User Name / ID{" "}
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  API Key
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  Active IP
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  Token ID
                </th>
                {/* <th scope="col" className="p-1 text-sm  font-bold  tracking-wider text-center border border-black" >Active IP Address</th> */}
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  Status Toggle
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  Current Env_Status
                </th>
                <th
                  scope="col"
                  className="p-1 text-sm  font-bold  tracking-wider text-center border border-black"
                >
                  ENV Toggle
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {/* {filteredItems.map((item) => ( */}
              {apiKeyReport && apiKeyReport.length > 0 ? (
                apiKeyReport.map((item, index) => (
                  <tr
                    className="my-2"
                    key={
                      (currentPage - 1) * paginationData?.per_page + index + 1
                    }
                  >
                    <td className="p-1 whitespace-nowrap text-sm font-medium text-gray-900 border border-black text-center">
                      {" "}
                      {(currentPage - 1) * paginationData?.per_page +
                        index +
                        1}{" "}
                    </td>
                    <td className="whitespace-nowrap text-sm font-medium text-gray-900 border border-black text-center">
                      {item?.userable ? (
                        <>
                          {item?.userable?.name}
                          <span className="text-[10px] text-gray-500 ml-1">
                            ({item?.userable?.user_id})
                          </span>
                        </>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center ">
                      {" "}
                      {item?.key || "-"}{" "}
                    </td>
                    <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center ">
                      {" "}
                      {item?.userable?.ips?.[0]?.ip_address || "-"}{" "}
                    </td>
                    <td className="whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                      {item?.userable?.token_id ? (
                        <button
                          className="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
                          onClick={() => {
                            setIps(item?.userable?.ips || []);
                            setShowIpTokenModal(true);
                          }}
                        >
                          View
                        </button>
                      ) : (
                        // item.userable.token_id
                        <button
                          className="px-2 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600"
                          onClick={() => {
                            setSelectedItem(item);
                            setShowModal(true);
                          }}
                        >
                          Add IP for Token
                        </button>
                      )}
                    </td>
                    {/* <td className="whitespace-nowrap text-sm text-gray-700 border border-black text-center"> */}
                    {/* {item?.userable?.ips?.find(ip => ip.status_id === 5)?.ip_address || "-"} */}

                    {/* {item?.userable?.token_id ? (
                          <button
                            className="px-3 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
                            onClick={() => {
                              setIps(item?.userable?.ips || []);
                              setShowIpModal(true);
                            }}
                          >
                            View Ips
                          </button> */}

                    {/* ) : (
                          <p>-</p>
                          )}
                      </td> */}

                    <td
                      className={
                        item?.status?.value === "active"
                          ? " whitespace-nowrap text-sm text-green-500 border border-black text-center"
                          : " whitespace-nowrap text-sm text-red-500 border border-black text-center"
                      }
                    >
                      {" "}
                      {item?.status.value}{" "}
                    </td>
                    <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center ">
                      <button
                        className="border h-8 w-16 rounded-2xl bg-white  shadow-lg  border-sky-400 "
                        onClick={() => statusToggle(item.id)}
                      >
                        <div
                          className={
                            item.status.value === "active"
                              ? "bg-green-500 translate-x-8 duration-200 transition-all rounded-full h-7 w-7"
                              : "bg-red-500 rounded-full h-7 w-7 translate-x-0.1 duration-200 transition-all"
                          }
                        />
                      </button>
                    </td>
                    <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center ">
                      {" "}
                      {item?.environment || "-"}{" "}
                    </td>
                    <td className="whitespace-nowrap border text-sm flex justify-center gap-1 border-black">
                      <span className="text-sm font-semibold text-red-500">
                        UAT
                      </span>{" "}
                      <button
                        className="border h-8 w-16 rounded-2xl bg-white  shadow-lg  border-sky-400 "
                        onClick={() => envToggle(item.id)}
                      >
                        <div
                          className={
                            item.environment === "production"
                              ? "bg-green-500 translate-x-8 duration-200 transition-all rounded-full h-7 w-7"
                              : "bg-red-500 rounded-full h-7 w-7 translate-x-0.1 duration-200 transition-all"
                          }
                        />
                      </button>{" "}
                      <span className="text-sm font-semibold text-green-500">
                        PROD
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="w-full flex justify-center items-center">
                  <td
                    colSpan="5"
                    className=" text-center flex justify-center items-center text-black text-xl"
                  >
                    <FaInbox />
                    Data Not Found
                  </td>
                </tr>
              )}

              {/* ))} */}
            </tbody>
          </table>
        </DivTag>

        <div className="flex justify-center my-2">
          <PaginationData
            currentPage={currentPage}
            lastPage={paginationData?.last_page}
            handlePage={handleSetPage}
          />
        </div>

        <ToastContainer />
      </DivTag>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-96 p-6">
            <h2 className="text-lg font-semibold mb-4">Generate Token</h2>

            <input
              type="text"
              placeholder="Enter IP Address"
              value={ipAddress}
              onChange={handleIpChange}
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            />

            {ipAddress && !isValidIP(ipAddress) && (
              <p className="text-red-500 text-sm mb-2">
                Please enter a valid IP address (example: 120.43.54.4)
              </p>
            )}

            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                onClick={() => {
                  setShowModal(false);
                  setIpAddress("");
                }}
              >
                Cancel
              </button>

              <button
                disabled={!isValidIP(ipAddress)}
                className={`px-4 py-2 text-white rounded 
    ${
      isValidIP(ipAddress)
        ? "bg-blue-600 hover:bg-blue-700"
        : "bg-gray-400 cursor-not-allowed"
    }
  `}
                onClick={() => {
                  handleGenerateToken(selectedItem, ipAddress);
                  setShowModal(false);
                  setIpAddress("");
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showIpTokenModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg w-[450px] p-6 shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">
                IP & Token List (Only Active)
              </h2>

              <button
                onClick={() => setShowIpTokenModal(false)}
                className="text-red-500 font-bold"
              >
                ✕
              </button>
            </div>

            <table className="w-full border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-sm">IP Address</th>
                  <th className="border p-2 text-sm">Token</th>
                </tr>
              </thead>

              <tbody>
                {ips?.length > 0 ? (
                  ips?.map((ip) => (
                    <tr key={ip.id}>
                      <td className="border p-2 text-center">
                        {ip?.ip_address}
                      </td>

                      <td className="border p-2 text-center break-all">
                        {ip?.token_id || (
                          <span className="text-red-500 text-xs">No Token</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center p-3">
                      No IP Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showIpModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-lg w-[450px] p-6 shadow-lg">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">IP List (Only Active)</h2>

              <button
                onClick={() => setShowIpModal(false)}
                className="text-red-500 font-bold"
              >
                ✕
              </button>
            </div>

            <table className="w-full border">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-sm">IP Address</th>
                </tr>
              </thead>

              <tbody>
                {ips?.length > 0 ? (
                  ips?.map((ip) => (
                    <tr key={ip.id}>
                      <td className="border p-2 text-center">
                        {ip?.ip_address}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center p-3">
                      No IP Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showApiKeyModal && <ApiKeyModal isOpen={showApiKeyModal} onClose={() => setShowApiKeyModal(false)}/>}
    </motion.div>
  );
};

export default CustomerReport;
